export const expense = {
  create_expense: "Créer une dépense",
  expense_list: "Liste des dépenses",
  expense_details: "Détails de la dépense",
  expense_edit: "Modifier la dépense",
  expense_delete: "Supprimer la dépense",
  expense_amount: "Montant de la dépense",
  expense_date: "Date de la dépense",
  expense_description: "Description de la dépense",
  expense_category: "Catégorie de la dépense",
  expense_payment_method: "Mode de paiement de la dépense",
  expense_status: "Statut de la dépense",
  expense_notes: "Notes sur la dépense",

  // Additions for UI labels/buttons
  cancel: "Annuler",
  preview: "Prévisualiser",
  save_draft: "Sauvegarder brouillon",
  creating: "Création...",
  finalize: "Finaliser la facture",
  from: "De",
  company: "Entreprise",
  choose_company: "Choisir une entreprise",
  recipient: "Destinataire",
  choose_client: "Choisir un client",
  select_client_first: "Sélectionnez d'abord un client",
  invoice_number: "N° de facture",
  due_date: "Date d'échéance",
  engagement_id: "Bon de commande",
  add_line: "Ajouter un article",
  add_field: "Ajouter un champ",
  payment_info: "Informations de paiement",
  payment_terms: "Modalités de paiement",
  note: "Note / Mentions particulières",
  subtotal: "Sous-total (HT)",
  discount: "Remise",
  vat: "TVA",
  total: "Total (TTC)",
  label: "Label",
  value: "Valeur",
  remove: "Supprimer",
  no_clients_for_company: "Aucun client pour cette entreprise",
  new_expense: "Nouvelle dépense",
  draft: "Brouillon",
};
